// reducers/nodepositionedReducer.js
import { createSlice } from "@reduxjs/toolkit";
export const nodepositionedslice = createSlice({
  name: "nodepositioned",
  initialState: {
    nodepositioneds: [],
    isEdit: false,
    autoSave: [],
    PlusBtnClicked: {
      isClicked: false,
      clickedNodeId: "",
    },
    MinusBtnClicked: {
      isClicked: false,
    },
  },
  reducers: {
    setIsEdit: (state, action) => {
      state.isEdit = action.payload;
    },
    setPlusClicked: (state, action) => {
      const { id, click } = action.payload;
      state.PlusBtnClicked.isClicked = click;
      state.PlusBtnClicked.clickedNodeId = id;
    },
    setMinusClicked: (state, action) => {
      const { click } = action.payload;
      state.MinusBtnClicked.isClicked = click;
    },
    Addnodepositioned: (state, action) => {
      state.nodepositioneds = action.payload;
    },
    AddNewnodepositioned: (state, action) => {
      state.nodepositioneds = [action.payload, ...state.nodepositioneds];
    },

    updatenodepositioneds: (state, action) => {
      let data = action.payload;
      let index = state.nodepositioneds.findIndex(
        (obj) => obj.id.toString() === data._id.toString()
      );

      if (index !== -1) {
        state.nodepositioneds[index] = {
          ...state.nodepositioneds[index],
          data: { ...data },
        };
      }
    },
    updatenodedatas: (state, action) => {
      let data = action.payload;
      state.autoSave = [...state.autoSave, ...data];
    },
    deleteNode: (state, action) => {
      const { nodepositionedId, commentId } = action.payload;
      let nodepositionedIndex = state.nodepositioneds.findIndex(
        (nodepositioned) =>
          nodepositioned._id.toString() === nodepositionedId.toString()
      );
      if (nodepositionedIndex !== -1) {
        let comments = state.nodepositioneds[nodepositionedIndex].comments;
        const updatedComments = comments.filter(
          (comment) => comment._id.toString() !== commentId.toString()
        );
        state.nodepositioneds[nodepositionedIndex].comments = updatedComments;
      }
    },
    deletenodepositioned: (state, action) => {
      let id = action.payload;
      const updatednodepositioneds = state.nodepositioneds.filter(function (
        nodepositioned
      ) {
        return nodepositioned._id !== id;
      });
      state.nodepositioneds = updatednodepositioneds;
    },
    editComment: (state, action) => {
      const { nodepositionedId, commentId, text } = action.payload;
      let nodepositionedIndex = state.nodepositioneds.findIndex(
        (nodepositioned) =>
          nodepositioned._id.toString() === nodepositionedId.toString()
      );
      if (nodepositionedIndex !== -1) {
        let commentIndex = state.nodepositioneds[
          nodepositionedIndex
        ].comments.findIndex(
          (comment) => comment._id.toString() === commentId.toString()
        );
        if (commentIndex !== -1) {
          state.nodepositioneds[nodepositionedIndex].comments[
            commentIndex
          ].text = text;
        }
      }
    },
    nodePositionlogout: (state) => {
      state.nodepositioneds = [];
      state.isEdit = false;
      state.autoSave = [];
      state.PlusBtnClicked = {
        isClicked: false,
        clickedNodeId: "",
      };
      state.MinusBtnClicked = {
        isClicked: false,
      };
    },
  },
});

export const selectnodepositioneds = (state) =>
  state.nodepositioned.nodepositioneds;
export const selectisEdit = (state) => state.nodepositioned.isEdit;
export const selectSave = (state) => state.nodepositioned.autoSave;


export const selectPlusNodeIdClick = (state) =>
  state.nodepositioned.PlusBtnClicked.clickedNodeId;
export const selectMinusButtonClick = (state) =>
  state.nodepositioned.MinusBtnClicked.isClicked;
export const selectPlusButtonClick = (state) =>
  state.nodepositioned.PlusBtnClicked.isClicked;

export const {
  Addnodepositioned,
  updatenodepositioneds,
  deleteNode,
  AddNewnodepositioned,
  deleteComment,
  editComment,
  setIsEdit,

  setPlusClicked,
  updatenodedatas,
  setMinusClicked,
  nodePositionlogout,
} = nodepositionedslice.actions; // actions
export default nodepositionedslice.reducer;
